"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var path_1 = require("../path");
var getValue = function (type, structure, fullPath) {
    // console.log(type, fullPath);
    // console.log(structure);
    fullPath = fullPath.map(function (x) {
        if (x.indexOf(engine_types_1.PathSymbol.INTERNAL) === 0) {
            var reg = new RegExp("^\\" + engine_types_1.PathSymbol.INTERNAL);
            var path_2 = x.replace(reg, "");
            var value = (0, exports.getValue)("internal", structure, path_2.split("."));
            return value;
        }
        else if (x.indexOf(engine_types_1.PathSymbol.EXTERNAL) === 0) {
            var reg = new RegExp("^\\" + engine_types_1.PathSymbol.EXTERNAL);
            var path_3 = x.replace(reg, "");
            var value = (0, exports.getValue)("external", structure, path_3.split("."));
            return value;
        }
        else {
            return x;
        }
    });
    var path = [type].concat(fullPath);
    var found = false;
    var node;
    var parts = [];
    while (path.length > 0 && !found) {
        var tempPath = path.join(".");
        node = structure[tempPath];
        if (!node) {
            parts.unshift(path.pop());
        }
        else {
            found = true;
        }
    }
    if (node) {
        if (parts.length > 0) {
            var value = parts.reduce(function (acc, x) {
                if (acc && x) {
                    if ((0, path_1.isPath)(acc)) {
                        if (acc instanceof path_1.PathObject) {
                            //@ts-ignore
                            acc = acc[x];
                        }
                        else {
                            acc = acc(x);
                        }
                    }
                    else {
                        acc = acc[x];
                    }
                }
                else {
                    acc = void 0;
                }
                return acc;
            }, node.value);
            return value;
        }
        else {
            return node.value;
        }
    }
};
exports.getValue = getValue;
//# sourceMappingURL=data:application/json;base64,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